import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { VerificationData } from 'src/app/domains/dids/models';

@Component({
  selector: 'gdp-vd-details-popup',
  templateUrl: './vd-details-popup.component.html',
  styleUrls: ['./vd-details-popup.component.scss']
})
export class VdDetailsPopupComponent implements OnInit {
  public verificationData: VerificationData;
  public currentLang: string;

  constructor(
    private activeModal: NgbActiveModal,
    private translate: TranslateService
    ) {}

  ngOnInit() {
    this.currentLang = this.translate.currentLang;
  }

  close() {
    this.activeModal.close();
  }

}
